module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 27.102V32h4.898l21.387-21.387-4.898-4.898zM31.282 2.151L29.849.718a2.448 2.448 0 0 0-3.465 0l-2.546 2.546 4.898 4.898 2.546-2.546a2.453 2.453 0 0 0 0-3.465z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pencil-2.js
// module id = 1340
// module chunks = 14